<template>
  <div>
    <div class="grid dashboard justify-content-center">
      <div class="col-10">
        <Card>
          <template #title>
            {{ $t("portalGranCliente.consultarFichero") }}
          </template>
          <template #content>
            <div class="grid">
              <div class="col-12 md:col-4">
                <InputText
                  v-model="nifConsultar"
                  :class="`input ${
                    validation.idLegal === false && 'p-invalid'
                  }`"
                  id="dni"
                  type="text"
                  :placeholder="$t('portalGranCliente.nifConsultar')"
                />
                <small v-if="validation.idLegal === false" class="p-invalid">{{
                  $t("datos.messages.error.campoIncorrecto")
                }}</small>
              </div>
              <div class="col-12 md:col-6">
                <Dropdown
                  v-model="carteraSel"
                  :class="`input ${
                    validation.carteraSel === false && 'p-invalid'
                  }`"
                  :options="carteras"
                  optionLabel="optionLabel"
                  :placeholder="$t('portalGranCliente.nombreConsulta')"
                />
                <small
                  v-if="validation.carteraSel === false"
                  class="p-invalid"
                  >{{ $t("datos.messages.error.campoIncorrecto") }}</small
                >
              </div>
              <div class="col-12 md:col-2">
                <Button
                  icon="pi pi-check"
                  :label="$t('portalGranCliente.consultar')"
                  @click="solicitudBusqueda()"
                />
              </div>
            </div>
          </template>
          <template #footer>
            <Button
              icon="pi pi-check"
              :label="$t('portalGranCliente.enlaceConsultas')"
              @click="goToListaConsultas()"
            />
          </template>
        </Card>
      </div>
      <div class="col-10 md:col-5">
        <Card class="myCard">
          <template #title>
            <div class="cardTitle">
              {{ $t("portalGranCliente.nuevoExpediente") }}
            </div>
          </template>
          <template #content>
            <div class="cardContent">
              <p>{{ $t("portalGranCliente.detalleNuevoExpediente") }}</p>
            </div>
          </template>
          <template #footer>
            <Button
              icon="pi pi-check"
              :label="$t('portalGranCliente.ir')"
              @click="goToNuevaOperacion()"
            />
          </template>
        </Card>
      </div>
      <div class="col-10 md:col-5">
        <Card class="myCard">
          <template #title>
            <div class="cardTitle">
              {{ $t("portalGranCliente.listadoExpedientes") }}
            </div>
          </template>
          <template #content>
            <div class="cardContent">
              <p>{{ $t("portalGranCliente.detalleListadoExpedientes") }}</p>
            </div>
          </template>
          <template #footer>
            <Button
              icon="pi pi-check"
              :label="$t('portalGranCliente.ir')"
              @click="goToListaExpedientesGrandesCuentas()"
            />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import StringMixin from "@/utils/strings";
import FilesMixin from "@/utils/files";
import RoutesMixin from "@/utils/routes";
import validations from "@/utils/validations.js";

import { ALTA_SOLICITUD_REQUEST_INPUT } from "@/graphQLQueries/ConsultasQueries";

export default {
  mixins: [StringMixin, FilesMixin, RoutesMixin],
  name: "AppGrandesCuentas",
  data() {
    return {
      carteras: [],
      carteraSel: null,
      nifConsultar: null,
      errors: [],
      validation: {
        idLegal: true,
        carteraSel: true,
      },
    };
  },
  created() {
    this.$store.state.cartera.results.forEach((cartera) => {
      if (cartera.cartera.usuarioCliente) {
        cartera.cartera.optionLabel =
          cartera.cartera.nombre +
          "-" +
          this.getFullName(
            cartera.cartera.usuarioCliente.nombre,
            cartera.cartera.usuarioCliente.apellidos,
            null
          );
        +this.carteras.push(cartera.cartera);
      }
    });
  },
  methods: {
    async solicitudBusqueda() {
      this.validateForm();
      if (!this.hasFormErrors()) {
        const base64Files = await this.convertFiles([]);
        const altaSolicitudRequest = this.generarAltaSolicitud(base64Files);

        this.$apollo
          .mutate({
            mutation: ALTA_SOLICITUD_REQUEST_INPUT,
            variables: {
              input: altaSolicitudRequest,
              idioma: this.$i18n.locale,
            },
          })
          .then((data) => {
            this.errors = [];
            const solicitudResponse = data.data.altaSolicitud;
            this.goToFichaConsulta(
              data.data.altaSolicitud.token,
              this.toJson(solicitudResponse.deudasSolicitudResponse)
            );
            return;
          })
          .catch((error) => {
            this.errors = [];
            error.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("consultaFichero.errores." + error.message)
              );
            });
            window.scrollTo(0, 0);
          });
      }
    },
    hasFormErrors() {
      return !(this.validation.idLegal && this.validation.carteraSel);
    },
    validateForm() {
      this.errors = [];
      this.validarNif();
      this.validarCarteraSel();
    },
    toJson(obj) {
      return JSON.stringify(obj);
    },
    validarCarteraSel() {
      if (this.carteraSel == null) {
        this.$set(this.validation, "carteraSel", false);
      } else {
        this.$set(this.validation, "carteraSel", true);
      }
    },
    generarAltaSolicitud(base64Files) {
      var opcion = "CONTRATO_VIGENTE";
      let datosClienteIdlegal = "";
      let datosClienteNombre = "";
      if (this.carteraSel) {
        datosClienteIdlegal = this.carteraSel.usuarioCliente.idLegal;
        datosClienteNombre = this.carteraSel.usuarioCliente.nombre
          ? this.carteraSel.usuarioCliente.nombre
          : this.carteraSel.usuarioCliente.razonSocial;
      }
      var datosClienteTipo =
        datosClienteIdlegal == this.$store.state.idLegal
          ? "PROPIA"
          : "TERCEROS";

      const isPropio = datosClienteTipo === "PROPIA";

      const altaRequest = {
        ficheros: base64Files,
        idLegalDeudor: this.nifConsultar,
        idLegalRepresentado: isPropio ? "" : datosClienteIdlegal,
        justificacion: opcion,
        origen: "WEB",
        plataforma: "icired",
        razonSocialRepresentado: datosClienteNombre,
        representacionPropia: isPropio,
        uuidSolicitante: this.$store.state.profile.uuid,
      };
      return altaRequest;
    },
    validarNif() {
      var cif = this.nifConsultar ? this.nifConsultar.toUpperCase() : "";
      if (validations.validateNifOrCif(cif)) {
        this.$set(this.validation, "idLegal", true);
      } else {
        this.$set(this.validation, "idLegal", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1250px) {
  .cardTitle {
    height: 70px !important;
  }
}
.cardContent {
  padding: 0 !important;
  height: 85px !important;
}
</style>